import React, { useCallback, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { Icon, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { sbatGroupPlaylistContent } from 'atoms/sbatGroupPlaylistContent';
import { useIngestSbatGroupPlaylistMutation } from 'features/classCreation';
import FieldErrors from 'components/FieldErrors';
import GlobalLoader from 'components/GlobalLoader';

function IngestButton({ sbatGroup, playlist }) {
  const content = useRecoilValue(sbatGroupPlaylistContent);
  const [ingestPlaylist, { error, isLoading, isSuccess }] =
    useIngestSbatGroupPlaylistMutation();

  const handleOnClick = useCallback(() => {
    ingestPlaylist({ sbatGroup, content, playlistId: playlist?.id });
  }, [ingestPlaylist, sbatGroup, content, playlist?.id]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Cue card content is successfully ingested!');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'Failed to ingest cue card content. Please try again after sometime!'
      );
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isLoading} />
      <Tappable
        disabled={playlist?.article?.content === content || isLoading}
        onClick={handleOnClick}
        className="btn btn-primary m-t-xs"
      >
        Validate & Ingest
      </Tappable>
      {error && (
        <div className="dark h3 m-t-xs">
          <Icon
            name="error"
            className="danger m-r-xxs"
          />
          Errors
        </div>
      )}
      <FieldErrors
        errors={error?.data}
        prefixName={false}
        name="errors"
      />
    </>
  );
}

export default IngestButton;
